// extracted by mini-css-extract-plugin
export default {"titleContainer":"PatientInfoTitle_titleContainer__mCNkv","editButton":"PatientInfoTitle_editButton__O6a6m"};